import { useState, useEffect } from 'react';
import { useMediaQuery } from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/es';

dayjs.locale('es');

function DatePick({ 
  name, 
  label = 'Fecha', 
  value, 
  onChange, 
  size = 'medium', 
  allowHistoricalDates = false,
  allowFutureDates = true,
  returnType = 'date',
  width,
  minWidth = 200,
  maxWidth = 300
}) {
  const [internalValue, setInternalValue] = useState(dayjs()); // Fecha actual por defecto
  const isMobile = useMediaQuery("(max-width: 768px)");

  useEffect(() => {
    // Si se pasa un valor (incluso null), actualiza el estado interno
    if (value !== undefined) {
      setInternalValue(value ? dayjs(value) : null);
    }
  }, [value]);

  const calculateWidth = () => {
    if (width) {
      return {
        width: `clamp(${minWidth}px, ${width}, ${maxWidth}px)`,
        minWidth: `${minWidth}px`,
        maxWidth: `${maxWidth}px`
      };
    }
    return {
      width: isMobile ? `${minWidth}px` : `${maxWidth}px`
    };
  };

  const handleChange = (newDate) => {
    setInternalValue(newDate);
    
    if (returnType === 'iso') {
      const isoDate = newDate ? newDate.toISOString() : null;
      onChange(name, isoDate);
    } else {
      onChange(name, newDate ? newDate.toDate() : null);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
      <DatePicker
        label={label}
        value={internalValue}
        onChange={handleChange}
        sx={{ 
          ...calculateWidth(),
          padding: "5px",
          '& .MuiInputBase-root': {
            height: size === 'small' ? '40px' : '56px'
          }
        }}
        slotProps={{
          textField: {
            variant: 'outlined',
            margin: 'dense',
            size: size === 'small' ? 'small' : 'medium',
            sx: {
              '& .MuiInputBase-input': { color: 'text.primary' },
              '& .MuiOutlinedInput-root': { backgroundColor: 'background.paper' },
              '& .MuiOutlinedInput-notchedOutline': { borderColor: 'divider' },
              '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'primary.main' },
              '& .MuiInputLabel-root': { color: 'text.secondary' }
            }
          }
        }}
        format="DD/MM/YYYY"
        minDate={allowHistoricalDates ? null : dayjs().startOf('day')}
        maxDate={allowFutureDates ? null : dayjs().endOf('day')}
      />
    </LocalizationProvider>
  );
}

export default DatePick;
